import api from "./api";

// Capa de servicios API del dominio "usuarios" (users) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).
// Nota: backend GET "/users" (paginado) y "/users/list" (simple, para selectores).

// --- Listados ---
export const listUsers = (params) => api.get("/users", { params });
export const listUsersSimple = (params) => api.get("/users/list", { params });
export const canAccessAgenda = () => api.get("/users/can-access-agenda");

// --- CRUD ---
export const getUser = (userId) => api.get(`/users/${userId}`);
export const createUser = (payload) => api.post("/users", payload);
export const updateUser = (userId, payload) => api.put(`/users/${userId}`, payload);
export const deleteUser = (userId) => api.delete(`/users/${userId}`);
